export const DEVELOPER_API_SUBMIT_URL = '/developer/api/submit_form';
export const DEVELOPER_API_FILE_UPLOAD_URL = '/developer/api/upload';
export const WEB_API_FILE_UPLOAD_URL = '/api/upload/files';
export const WEB_API_SUBMIT_URL = '/api/submit_form';
